<template>
  <el-card class="ds-detail" style="position:relative;z-index:0;width:100%">
    <div slot="header" class="clearfix">
      <span>{{item.Name}}</span>
      <el-button @click="$router.back()" class="pull-right">
        <i class="fa fa-chevron-left fa-fw"></i> 返回
      </el-button>
    </div>
    <el-tabs v-model="activeName" @tab-click="handleClick">
      <el-tab-pane label="基本信息" name="0">
        <table border="1" bordercolor="#dedede" style="width: 100%;border-collapse:collapse;">
          <tr>
            <th width="12%">站点名称</th>
            <td width="38%">{{item.Name}}</td>
            <th width="12%">站点类型</th>
            <td width="38%">{{item.Sn}}</td>
          </tr>
          <tr>
            <th>业务类型</th>
            <td>{{item.MN}}</td>
            <th>区域</th>
            <td>{{$sys.DS_STATUS[item.Status]}}</td>
          </tr>
          <tr>
            <th>站点状态</th>
            <td>{{item.ProductionDay}}</td>
            <th>入网日期</th>
            <td>{{item.PurchaseUnit}}</td>
          </tr>
          <tr>
            <th>网络情况</th>
            <td>{{item.Recipient}}</td>
            <th>SIM卡序列号</th>
            <td>{{item.HardwareVersion}}</td>
          </tr>
          <tr>
            <th>质保年限</th>
            <td>
              <el-tag v-if="item.Check === 1" type="warning">未审核</el-tag>
              <el-tag v-else-if="item.Check === 2" type="success">已审核</el-tag>
              <span v-else>-</span>
            </td>
            <th>详细地址</th>
            <td>{{item.Comment}}</td>
          </tr>
          <tr>
            <th>质保开始日期</th>
            <td>{{item.Recipient}}</td>
            <th>质保结束日期</th>
            <td>{{item.HardwareVersion}}</td>
          </tr>
          <tr>
            <th>备注</th>
            <td>{{item.Recipient}}</td>
            <th>备注</th>
            <td>{{item.HardwareVersion}}</td>
          </tr>
        </table>
      </el-tab-pane>
      <el-tab-pane label="运维信息" name="1">
        <table border="1" bordercolor="#dedede" style="width: 100%;border-collapse:collapse;">
          <tr>
            <th width="12%">运维单位</th>
            <td width="38%">{{item.Name}}</td>
            <th width="12%">运维单位</th>
            <td width="38%">{{item.Sn}}</td>
          </tr>
          <tr>
            <th>运维人员</th>
            <td>{{item.MN}}</td>
            <th>联系方式</th>
            <td>{{$sys.DS_STATUS[item.Status]}}</td>
          </tr>
          <tr>
            <th>TV ID</th>
            <td>{{item.ProductionDay}}</td>
            <th>TV 密码</th>
            <td>{{item.PurchaseUnit}}</td>
          </tr>
        </table>
      </el-tab-pane>
      <el-tab-pane label="硬件信息" name="2">
        <table border="1" bordercolor="#dedede" style="width: 100%;border-collapse:collapse;">
          <tr>
            <th width="12%">工控机品牌</th>
            <td width="38%">{{item.Name}}</td>
            <th width="12%">工控机型号</th>
            <td width="38%">{{item.Sn}}</td>
          </tr>
          <tr>
            <th>CPU</th>
            <td>{{item.MN}}</td>
            <th>内存</th>
            <td>{{$sys.DS_STATUS[item.Status]}}</td>
          </tr>
          <tr>
            <th>操作系统版本</th>
            <td>{{item.ProductionDay}}</td>
            <th>操作系统安装时间</th>
            <td>{{item.PurchaseUnit}}</td>
          </tr>
        </table>
      </el-tab-pane>
      <el-tab-pane label="安装产品信息" name="3">
        <table border="1" bordercolor="#dedede" style="width: 100%;border-collapse:collapse;">
          <tr>
            <th width="12%">软件名称</th>
            <td width="38%">{{item.Name}}</td>
            <th width="12%">版本</th>
            <td width="38%">{{item.Sn}}</td>
          </tr>
          <tr>
            <th>当前版本</th>
            <td>{{item.MN}}</td>
            <th>可升级版本</th>
            <td>{{$sys.DS_STATUS[item.Status]}}</td>
          </tr>
          <tr>
            <th>授权码</th>
            <td>{{item.ProductionDay}}</td>
            <th>机器码</th>
            <td>{{item.PurchaseUnit}}</td>
          </tr>
        </table>
      </el-tab-pane>
    </el-tabs>
  </el-card>
</template>

<script>
export default {
  data() {
    return {
      activeName: '0',
      item: {},
      former: {
        Begin_at: null,
        Finish_at: null,
        data: 1,
      },
      itemList: [],
      pager: {
        total: 0,
        page: 1,
        size: 15,
      },
      loading: false,
      visible1: false,
      visible2: false,
      // 通过审核按钮的禁用
      disChkDeviceBtn: false,
      // 还原审核状态按钮的禁用
      disUnchkdeviceBtn: false,
    };
  },
  mounted() {
    this.getItemData();
  },
  methods: {
    getItemData() {
      const params = {
        with: 'SoftwareVersion',
      };
      this.$axios.get(`dcidevice/${this.$route.params.ID}`, { params }).then((response) => {
        this.item = response.data;
        // 通过审核按钮的禁用
        this.disChkDeviceBtn = this.item.Check !== 1;
        // 还原审核状态按钮的禁用
        this.disUnchkdeviceBtn = this.item.Check === 1;
      }).catch(({ response }) => {
        this.$sys.alarmResponse(response);
      }).finally(() => {
        this.loading = false;
      });
    },
    getItemList() {
    },
    handleClick() {
    },
    onSubmitQuery() {
    },
    // 翻页
    onChangePage(page) {
      this.pager.page = page;
      this.getItemList();
    },
    // 修改审核状态（通过还是还原）
    changeCheck(str) {
      this.$axios.put(`${str}/${this.item.ID}`).then(() => {
        this.getItemData();
        this.$message({
          message: str === 'checkdevice' ? '审核通过' : '成功还原审核状态',
          type: 'success',
        });
      }, ({ response }) => {
        this.$sys.alarmResponse(response);
      });
      if (str === 'checkdevice') {
        this.visible1 = false;
        this.disChkDeviceBtn = true;
        this.disUnchkdeviceBtn = false;
      } else {
        this.visible2 = false;
        this.disUnchkdeviceBtn = true;
        this.disChkDeviceBtn = false;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.ds-detail {
  .el-tabs__header {
    z-index: 0;
  }
  .fix-width {
    width: 120px;
  }
  table th td,
  table tr td {
    padding: 2px 5px;
    height: 30px;
    line-height: 30px;
  }
  table th {
    text-align: left;
    padding-left: 5px;
    color: #646566;
  }
  .border-style {
    height: 28px;
    line-height: 28px;
    border-radius: 0 15px 15px 0;
    border-left: 3px solid #cdcdcd;
    padding-left: 5px;
    margin-bottom: 10px;
    background-color: #ebf3f9;
    color: #646566;
  }
}
</style>
